import { ChangeEvent, useState } from 'react';
import { TextField, TextFieldProps } from '@mui/material';

const DECIMAL_DRAFT = /^\d*\.?\d*$/;
const INTEGER_DRAFT = /^\d*$/;

type DecimalFieldProps = Omit<TextFieldProps, 'value' | 'onChange' | 'type'> & {
  value: number;
  onValueChange: (value: number) => void;
  integer?: boolean;
};

/** Numeric input that keeps the typed text, so drafts like "0." or "0.0" survive until they parse. */
export const DecimalField = ({ value, onValueChange, integer, inputProps, ...rest }: DecimalFieldProps) => {
  const [text, setText] = useState(value ? String(value) : '');
  const pattern = integer ? INTEGER_DRAFT : DECIMAL_DRAFT;

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    // Accept a comma decimal separator from European keyboards.
    const next = e.target.value.replace(',', '.');
    if (!pattern.test(next)) return;
    setText(next);
    const parsed = Number(next);
    onValueChange(Number.isFinite(parsed) ? parsed : 0);
  };

  return (
    <TextField {...rest} value={text} onChange={handleChange} inputProps={{ ...inputProps, inputMode: integer ? 'numeric' : 'decimal' }} />
  );
};
